import React from 'react'
import { Badge, Card } from 'reactstrap';
import { UserAvatar } from '../../../../components/Component';

function TodayUsers({ today_users }) {
    return (
        <Card className="h-100">
            <div className="card-inner">
                <div className="card-title-group mb-2">
                    <div className="card-title">
                        <h6 className="title">Users Registered Today</h6>
                    </div>
                </div>
                <ul className="nk-top-products">
                    {today_users.map((user, idx) => (
                        <li className="item" key={idx}>
                            <div className="thumb">
                                <UserAvatar className="sm" theme='primary-dim' text={user?.name?.charAt(0)?.toUpperCase()} ></UserAvatar>
                            </div>
                            <div className="info">
                                <div className="title">{user?.name}</div>
                                <div className="price">{user?.phone}</div>
                            </div>
                            <div className="total">
                                <div className="amount"><Badge color='info'>{user?.roles[0]?.name}</Badge></div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </Card>
    )
}

export default TodayUsers